import { createRoot } from 'react-dom/client'
import React from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import App from './App'
import './index.css'
import './infrastructure/localization/i18n'
import { Provider } from 'react-redux'
import { store } from './infrastructure/store'
import { BrowserRouter } from 'react-router-dom'
import 'material-icons/iconfont/material-icons.css'
import { MsalProvider } from '@azure/msal-react'
import { Configuration, PublicClientApplication } from '@azure/msal-browser'
import { LicenseManager } from 'ag-grid-enterprise'
import TagManager from '@sooro-io/react-gtm-module'
import { MSCLIENTID } from './infrastructure/constant/constants'

const licenseKey =
  'Using_this_{AG_Grid}_Enterprise_key_{AG-051350}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{SERTEC_FARMA_S.L.}_is_granted_a_{Multiple_Applications}_Developer_License_for_{1})_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{28_December_2024}____[v3]_[01]_MTczNTM0NDAwMDAwMA==635fe89392724cc31b6f8eb48107db61'
const cleanedLicenseKey =
  licenseKey && licenseKey.replace(/[\u200B-\u200D\uFEFF]/g, '')
LicenseManager.setLicenseKey(cleanedLicenseKey)

const configuration: Configuration = {
  auth: {
    clientId: MSCLIENTID!!,
    authority: 'https://login.microsoftonline.com/common',
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
}

console.log({configuration})
const pca = new PublicClientApplication(configuration)
TagManager.initialize({ gtmId: 'GTM-NWQRHK7C' })

createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <BrowserRouter>
      <MsalProvider instance={pca}>
        <App />
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </MsalProvider>
    </BrowserRouter>
  </Provider>
)